import React, { useContext, Ref, FunctionComponent } from 'react';
import ReactDOM from 'react-dom';

export const FooterContext = React.createContext<Ref<HTMLDivElement>>(null);

const FooterPortal: FunctionComponent = ({ children }) => {
  const footerRef = useContext(FooterContext);
  if (typeof footerRef === 'object' && footerRef && footerRef.current) {
    return ReactDOM.createPortal(children, footerRef.current);
  }

  return null;
};

export const FooterContainer: FunctionComponent = () => {
  const footerRef = useContext(FooterContext);
  return <div ref={footerRef} />;
};

export default FooterPortal;
